import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Close, Delete } from "@mui/icons-material";
import { useState } from "react";
import { useDeletePandaVideo } from "../api/deletePandaVideo";

export default function DeletePandaVideo({ children, video }) {
  const deletePandaVideoMutation = useDeletePandaVideo();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleCloseDialog = (e) => {
    setDialogOpen(false);
  };
  const handleOpenDialog = (e) => {
    setDialogOpen(true);
  };
  const handleConfirm = () => {
    deletePandaVideoMutation.mutate(
      { id: video.id },
      {
        onSuccess: () => {
          handleCloseDialog();
        },
      }
    );
  };

  return (
    <>
      {children({
        onClick: handleOpenDialog,
        isLoading: deletePandaVideoMutation.isLoading,
        disabled: video.used,
      })}

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle></DialogTitle>
        <IconButton
          sx={{ position: "absolute", top: 3, right: 3 }}
          onClick={handleCloseDialog}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            Esse vídeo será deletado permanentemente, essa ação não é
            reversível. <br />
            Tem certeza que deseja deletar esse vídeo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="error">
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            onClick={handleConfirm}
            loading={deletePandaVideoMutation.isLoading}
            startIcon={<Delete />}
          >
            Deletar
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
